import Footer from './Footer';
import styles from './layout.module.scss';
import { useEffect, useState } from 'react';

export default function RootLayout({ children, style = {}, className = '' }) {
  const [normal, setNormal] = useState(true);

  useEffect(() => {
    const fn = () => {
      if (window.orientation == 90 || window.orientation == -90) {
        // 横屏
        setTimeout(() => {
          if (window.innerWidth > 1.6 * window.innerHeight && window.innerHeight < 500 && window.innerWidth < 900) {
            setNormal(false);
          }
        }, 100);
      } else {
        setNormal(true);
      }
    };
    window.addEventListener('orientationchange', fn);
    if (window.innerWidth > 1.6 * window.innerHeight && window.innerHeight < 500 && window.innerWidth < 900) {
      setNormal(false);
    }
    return () => {
      window.removeEventListener('orientationchange', fn);
    };
  }, []);

  if (normal) {
    return (
      <>
        <div className={`${styles.body} ${className}`} style={{ ...style }}>
          {children}
        </div>
        <Footer />
      </>
    );
  } else {
    return (
      <div
        style={{
          flexDirection: 'column',
          height: '100%',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div style={{ fontSize: 60, lineHeight: 1.3 }}>🙃</div>
        <h3 style={{ fontWeight: 600, fontSize: 24, marginBottom: 5 }}>Catch Us On The Flip Side</h3>
        <div style={{ color: '#505965', fontSize: 14 }}>Enjoy matching up from a portrait view.</div>
      </div>
    );
  }
}
